import $ from "jquery/dist/jquery";

$(() => {
  function loadRegistryInfo(e) {
    let ic = $(e.attr("data-target-ic-field")).val();
    let dic = $(e.attr("data-target-dic-field")).val();

    $.ajax({
      method: "post",
      url: window.NXURLS.URL_ESHOP_LOAD_REGISTRY_INFO,
      data: {
        ic: ic,
        dic: dic,
      },
    })
      .done((r) => {
        if (r.name) {
          $('input[name="invoice_company"]').val(r.name);
        }
        if (r.street) {
          $('input[name="invoice_street"]').val(r.street);
        }
        if (r.city) {
          $('input[name="invoice_city"]').val(r.city);
        }
        if (r.zip) {
          $('input[name="invoice_zip"]').val(r.zip);
        }
        if (r.ic) {
          $('input[name="invoice_ic"]').val(r.ic);
        }
        if (r.dic) {
          $('input[name="invoice_dic"]').val(r.dic);
        }

        NXCMS.toast(r.success_message, 4000);
      })
      .fail((r) => {
        NXCMS.toast("Nepovedlo se ověřit!", 4000);
      });
  }

  $(document).on("click", ".load-registry-info", (e) => {
    e.preventDefault();
    loadRegistryInfo($(e.target));
  });
});
